// Animation constants for the clip suggestion video player
export const ANIMATION_DURATION_MS = 500;
export const ANIMATION_DURATION_S = `${ANIMATION_DURATION_MS / 1000}s`;

// CSS custom property name for use in LESS files
export const CSS_VARS = {
  ANIMATION_DURATION: '--clip-select-player-animation-duration',
} as const;
